module.exports = __webpack_public_path__ + "img/small-abstract-3.876a0ee.svg";